import styled, { css } from 'styled-components';
import { Box, Paper, makeStyles } from '@material-ui/core';
import { colorSet } from '@components/Provider';

export const MuiBox = styled(Box)`
  min-height: 100vh;
  background-color: ${colorSet.gray000};
  padding: 100px 60px;
  ${({ theme }) => css`
    ${theme.breakpoints.down('xs')} {
      padding: 22px 0px;
    }
  `}
`;

export const useCardStyle = makeStyles((theme) => ({
  root: {
    border: `1px solid ${colorSet.gray400}`,
    padding: 32,
    borderRadius: 8,
    [theme.breakpoints.down('xs')]: {
      padding: '32px 16px'
    },
    '& .title': {
      fontWeight: 500,
      marginBottom: 20
    },
    '& .sub-title': {
      textAlign: 'left',
      marginBottom: 20
    },
    '& .MuiTextField-root': {
      marginBottom: 20
    },
    '& .checkbox-wrapper': {
      width: '100%',
      margin: 0,
      marginBottom: '20px',
      '& .MuiCheckbox-root': {
        padding: '0px',
        marginRight: '10px'
      }
    },
    '& .submit-btn': {
      marginBottom: '20px'
    },
    '& .question-text': {
      cursor: 'pointer',
      color: `${colorSet.primary500}`
    },

    '& .complete-icon': {
      fontSize: '40px',
      color: `${colorSet.primary900}`,
      marginBottom: 23
    },
    '& .description': {
      textAlign: 'center'
    },
    '& .remove-red-eye-icon': {
      cursor: 'pointer',
      '& .MuiSvgIcon-root': {
        color: colorSet.gray700
      }
    }
  },
  containerXs: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    maxWidth: 424,
    height: '100%',
    [theme.breakpoints.down('xs')]: {
      padding: '0px 16px'
    }
  },
  inputRoot: {
    '& input, textarea': {
      fontSize: 14,
      wordBreak: 'keep-all'
    }
  },
  logoRoot: {
    marginBottom: 40
  },
  cardTitle: {
    marginBottom: 32
  },
  textfieldGridContainer: {
    '& .remove-red-eye-icon': {
      cursor: 'pointer',
      '& .MuiSvgIcon-root': {
        color: colorSet.gray700
      }
    }
  },
  textfieldInputRoot: {
    '&::placeholder': {
      ...theme.typography.body2,
      color: '#939fa5'
    },
    [theme.breakpoints.down('sm')]: {
      paddingTop: 11.5,
      paddingBottom: 11.5
    }
  },
  notchedOutline: {
    border: `1px solid #0000003B`
  },
  verticalDivider: {
    backgroundColor: colorSet.gray400,
    height: 12,
    margin: '0px 6px'
  },
  subButtonGridContainer: {
    marginTop: 24,
    marginBottom: 24
  },
  checkboxContainer: {
    '& .MuiTypography-body2': {
      marginTop: `0 !important`
    },
    '& svg': {
      width: 20,
      height: 20
    }
  },
  divider: {
    color: colorSet.gray400,
    width: '100%'
  },
  grayLogo: {
    marginTop: 32,
    marginBottom: 16
  },
  infoText: {
    whiteSpace: 'nowrap'
  }
}));

export const CheckBoxWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
  > * {
    line-height: 40px;
  }
  .input-box {
    display: block;
    width: calc(100% - 102px);
  }
`;

export const MuiPaper = styled(Paper)`
  padding: 40px;
  .title {
    font-weight: 500;
    margin-bottom: 20px;
  }
  .sub-title {
    text-align: left;
    margin-bottom: 20px;
  }
  .MuiTextField-root {
    margin-bottom: 20px;
  }
  .checkbox-wrapper {
    width: 100%;
    margin: 0px;
    margin-bottom: 20px;
    .MuiCheckbox-root {
      padding: 0px;
      margin-right: 10px;
    }
  }
  .submit-btn {
    margin-bottom: 20px;
  }
  .question-text {
    cursor: pointer;
    color: ${colorSet.primary500};
  }

  .complete-icon {
    font-size: 40px;
    color: ${colorSet.primary900};
    margin-bottom: 23px;
  }
  .description {
    text-align: center;
  }
`;
